module.exports = __webpack_public_path__ + "static/media/survey_completed.e60e7b3b.svg";